<template>
  <a-modal
    title="配方版本管理"
    :visible='visible.vision'
    :maskClosable="false"
    :destroyOnClose="true"
    :zIndex="1000"
    width="700px"
    okText="确认删除"
    cancelText="取消"
    @cancel="cancel"
    :row-key="record => record.id"
  >
    <a-table 
      ref="listRef"
      :columns="columns"
      :data-source="tableList"
      class="tableBox"
      :pagination="pagination"
      row-key="id"
      :loading="versionLoading"
      :row-selection="rowSelection"
      :scroll="{ y: 350 }"
    >
    <template slot="remark" slot-scope="t,record">
      <a-tooltip :title="record.remark">
        <div class="ellipsis-2">{{ record.remark }}</div>
      </a-tooltip>
    </template>
    <template slot="version" slot-scope="t,record">
      V{{ record.version }} [{{ record.createTime }}]
    </template>
    <template slot="x" slot-scope="t,record">
      <!-- <a-button @click="changeVersion(record)"></a-button> -->
      <span v-if="record.status === 1" style="color: #ccc;">已激活</span>
      <div v-else>
        <a @click="() => changeVersion(record)">激活</a>
        <a-divider type="vertical" />
        <a style="color: red;" @click="() => comfirmDelete([record.id])">删除</a>
      </div>
    </template>
    </a-table>
    <template slot="footer">
      <div style="position: relative;">
        <p class="pText">已选中<span class="fontRed">{{selectedRowKeys.length}}</span>个版本</p>
      </div>
      <a-button @click="cancel">取消</a-button>
      <a-button @click="ok" type="danger">确认删除</a-button>
    </template>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '版本号',
    dataIndex: 'version',
    scopedSlots: {customRender: 'version'},
  },
  {
    title: '生成日期',
    dataIndex: 'createTime',
    scopedSlots: {customRender: 'createTime'},
  },
  {
    title: '备注',
    dataIndex: 'remark',
    scopedSlots: {customRender: 'remark'},
  },
  {
    title: '操作',
    dataIndex: 'x',
    scopedSlots: {customRender: 'x'},
  },
]
import { nhfMixins } from '../../untils'
export default {
  mixins:[nhfMixins],
  data(){
    return {
      isShow: true,
      selectedRowKeys: [],
      selectedRows:[],
      columns,
      tableList:[],
      versionLoading: false,
      pagination: {
        total:0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1
          this.pagination.pageSize = pageSize
          this.getList({current:1,pageSize})
        } //每页多少条
      },
    }
  },
  computed:{
    rowSelection() {
      return {
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
          // this.selectedRows = selectedRows
        },
        selectedRowKeys: this.selectedRowKeys,
        onSelectAll: (selected, selectedRows, changeRows) => {
          if (selected) {
            changeRows.forEach((el) => {
              if (!this.selectedRowKeys.includes(el.id)) {
                this.selectedRowKeys.push(el.id);
              }
            });
          } else {
            this.selectedRowKeys = [];
          }
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.status === 1
          },
        }),
      };
    },
  },
  watch:{
    'visible.vision': {
      handler(val){
        if(val) this.getList({pageSize: 20, current: 1})
      },
      deep: true,
    }
  },
  methods: {
    ok(){
      if(this.selectedRowKeys.length === 0){
        this.$message.warning('请选择需要删除的版本')
        return
      }
      this.comfirmDelete(this.selectedRowKeys)
    },
    cancel(){
      this.selectedRowKeys = []
      this.toggleVisible('vision')
    },
    // onSelectChange(){},
    async getList(pagination){
      let {id} = this.getVisionRaw || {}
      let { pageSize, current } = pagination || this.pagination;
      let res = await this.fetchGet({
        actions: this.getFormulaHisVersionList,
        data: { formulaId: id,current,size: pageSize },
        name: "version",
        loading: "versionLoading",
      });
      let {success,data} = res || {}
      if(success){
        let {records,total,current,size} = data || {}
        this.tableList = records || []
        this.pagination.total = total
        this.pagination.current = current
        this.pagination.pageSize = size
      }
    },
    async changeVersion(record){
      let res = await this.fetchGet({
        actions: this.activationFormulaHisVersion,
        data: { productId: record.id },
        loading: 'versionLoading'
      });
      let {success} = res || {}
      if(success) {
        this.getList()
        this.$emit('refreshList')
      }

      this.selectedRowKeys = []
    },
    comfirmDelete(idsArr){
      this.$confirm({
        title: '提示',
        content: <p><span style="color: red;">版本删除后，配方列表页将不再展示当前版本</span>，你还要继续吗？</p>,
        okText: '继续',
        cancelText: "取消",
        okType: 'danger',
        onOk: () => {
          this.deleteVision(idsArr)
        },
        
      });
    },
    async deleteVision(idsArr){
      let ids = idsArr.join(',')
      await this.fetchPost({
        actions: this.batchDelFormulaHisVersion,
        data: { ids },
        loading: 'versionLoading'
      })
      this.getList()
      this.selectedRowKeys = []
    }
  }
}
</script>

<style lang="scss" scoped>
.pText{
  position: absolute;
  top: 0;
  left: 0;
}
.fontRed{
  color: #ff4d4f;
}
.ellipsis-2{
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>